import { render, staticRenderFns } from "./ExtendForm.vue?vue&type=template&id=45b7216a"
import script from "./ExtendForm.vue?vue&type=script&lang=js"
export * from "./ExtendForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports